import { switcher } from '../utils';
import { ACTIONS } from '../../const';

export const defaultSharingStudents = {
    learners: [],
};

export default switcher(
    {},
    {
        [ACTIONS.SET_SHARING_STUDENTS](state, action) {
            return action.data;
        },
    }
);



// WEBPACK FOOTER //
// ./src/reducers/content/sharing_students.js